import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';
import ticket from './ticket/reducer';
import occurrence from './occurrence/reducer';

export default combineReducers({
  auth,
  user,
  ticket,
  occurrence,
});
